/**
 * Stock Chart Viewer - Watchlist Feature
 */

import { state } from '../state.js';
import { elements } from '../ui/dom.js';

export function isInWatchlist(symbol) {
    return state.watchlist.includes(symbol.toUpperCase());
}

export function addToWatchlist(symbol) {
    symbol = symbol.toUpperCase();
    if (!isInWatchlist(symbol)) {
        state.watchlist.push(symbol);
        saveWatchlist();
        renderWatchlist();
        updateWatchlistButton();
    }
}

export function removeFromWatchlist(symbol) {
    symbol = symbol.toUpperCase();
    const index = state.watchlist.indexOf(symbol);
    if (index > -1) {
        state.watchlist.splice(index, 1);
        saveWatchlist();
        renderWatchlist();
        updateWatchlistButton();
    }
}

export function toggleWatchlist() {
    if (!state.currentSymbol) return;

    if (isInWatchlist(state.currentSymbol)) {
        removeFromWatchlist(state.currentSymbol);
    } else {
        addToWatchlist(state.currentSymbol);
    }
}

export function saveWatchlist() {
    localStorage.setItem('stockWatchlist', JSON.stringify(state.watchlist));
}

export function renderWatchlist() {
    const container = elements.watchlistItems;
    const count = elements.watchlistCount;

    count.textContent = state.watchlist.length;

    if (state.watchlist.length === 0) {
        container.innerHTML = '<p class="watchlist-empty">No stocks in watchlist</p>';
        return;
    }

    container.innerHTML = state.watchlist.map(symbol => `
        <div class="watchlist-item" data-symbol="${symbol}">
            <span class="symbol">${symbol}</span>
            <button class="remove-btn" data-symbol="${symbol}" title="Remove">×</button>
        </div>
    `).join('');
}

export function updateWatchlistButton() {
    if (!state.currentSymbol) {
        elements.watchlistBtn.classList.remove('active');
        elements.watchlistBtn.querySelector('.star-icon').textContent = '☆';
        return;
    }

    if (isInWatchlist(state.currentSymbol)) {
        elements.watchlistBtn.classList.add('active');
        elements.watchlistBtn.querySelector('.star-icon').textContent = '★';
    } else {
        elements.watchlistBtn.classList.remove('active');
        elements.watchlistBtn.querySelector('.star-icon').textContent = '☆';
    }
}
